export namespace SetUtils {
  export function compare<T>(a: Set<T>, b: Set<T>) {
    return a.size === b.size && [...a].every(value => b.has(value));
  }
}
